import { Button } from "primereact/button";
import { useState } from "react";
import { Tooltip } from 'primereact/tooltip';

export function FormInput({ register, errors, id, name, step,
  labelText, type, rules, disabled = false,
  placeholder, labelClass = "", enterClick,
  onChange, onFocus, maxLength, onInput, style = {}, infoTooltip = "",
  wrapperClass, wrapperStyle = {}, tipSmall, value, inputClass}) {
  //   console.log('id',id);
  // console.log('errors',errors);
  // console.log('errors[id]',errors[id]);
  const [passwordView, setPasswordView] = useState(false)
  const [inputType, setInputType] = useState(type)
  let errorObj = undefined;
  if (id.split('.').length > 1 && Object.keys(errors).length > 0) {
    let tarErrors = errors;
    let errorObjCheckIdx = 0;
    const idArr = id.split('.');
    // console.log('複雜欄位檢核', idArr)
    idArr.forEach((res, idx) => {
      if (tarErrors[res]) {
        errorObjCheckIdx = idx
        tarErrors = tarErrors[res];
      }
    })

    if (errorObjCheckIdx === idArr.length - 1) {
      errorObj = tarErrors
    } else errorObj = undefined;
  }

  return (
    <div className={`custom-input ${wrapperClass} ${type === "password" ? "has-btn" : ""}`} style={wrapperStyle}>
      {
        labelText ? (
          <div className="form-label">
            <label htmlFor={id} className={`form-label ${labelClass}`
            }>{labelText}</label>
            {
              tipSmall && (<div style={{color:'gray'}}><small>{tipSmall}</small></div>)
            }
            {
              infoTooltip !== "" ? (<>
                <Tooltip target=".pi-info-circle" />
                <span><i className="pi pi-info-circle ml-1" data-pr-tooltip={infoTooltip}></i></span>
              </>
              ) : <></>
            }
          </div>
        )
          : <></>
      }
      <input
        step={step}
        maxLength={maxLength}
        onChange={onChange}
        onInput={onInput}
        onKeyDown={enterClick}
        placeholder={placeholder}
        disabled={disabled}
        onFocus={onFocus}
        id={id}
        name={name}
        type={inputType}
        autoComplete={type==='password'?'new-password':type}
        {...register(id, rules)}
        className={`${inputClass} p-inputtext p-component ${(errors[id] ? errors[id] : ((id.split('.').length > 1 && errorObj) ? errorObj : false)) && ' p-invalid'} `}
        style={style}
        value={value}
      />

      {(errors[id] ? errors[id] : errorObj) && (
        <small className='p-error pt-1'>{errors[id] ? (errors?.[id]?.message) : errorObj.message}</small>
      )}
      {
        type === "password" && (
          <div className="absolute right-0" style={{
            top: '28px',
          }}>
            <Button
              type="button"
              icon={`pi  ${passwordView ? "pi-eye" : "pi-eye-slash"}`}
              severity="secondary"
              text
              onClick={() => {
                setPasswordView(!passwordView)
                setInputType(passwordView ? "password" : "text")
              }}
            />
          </div>
        )
      }
    </div>
  )
}
